import { isEqual } from 'underscore';
import { DateQueryTypeEnum } from '../../../api/mentions/enum/date-query-type.enum';
import { ListTypeEnum } from '../../../Common/TargetingShared/enum/list-type.enum';
import { DateQueryModel } from '../../Forms/models/date-query.model';
import { DistributionStatus } from '../../TargetingShared/enum/distribution-status.enum';
import { SearchModeEnum } from '../../TargetingShared/enum/search-mode.enum';

export class ChartContentFilterModel {
    names: string[];
    status?: DistributionStatus[];
    searchType?: SearchModeEnum[];
    listType?: ListTypeEnum[];
    createdBy?: number[];
    modifiedBy?: number[];
    createdDate?: DateQueryModel;
    modifiedDate?: DateQueryModel;

    constructor(apimodel?) {
        if (apimodel) {
            this.names = apimodel.names;
            this.status = apimodel.status;
            this.searchType = apimodel.searchType;
            this.listType = apimodel.listType;
            this.createdBy = apimodel.createdBy;
            this.modifiedBy = apimodel.modifiedBy;
            this.createdDate = DateQueryModel.clone(apimodel.createdDate);
            this.modifiedDate = DateQueryModel.clone(apimodel.modifiedDate);
        } else {
            this.names = [];
            this.status = [];
            this.searchType = [];
            this.listType = [];
            this.createdBy = [];
            this.modifiedBy = [];
            this.createdDate = new DateQueryModel();
            this.createdDate.type = DateQueryTypeEnum.ALL;
            this.modifiedDate = new DateQueryModel();
            this.modifiedDate.type = DateQueryTypeEnum.ALL;
        }
    }

    clone(): ChartContentFilterModel {
        const clone = new ChartContentFilterModel();
        clone.names = [...this.names];
        clone.status = [...this.status];
        clone.searchType = [...this.searchType];
        clone.listType = [...this.listType];
        clone.createdBy = [...this.createdBy];
        clone.modifiedBy = [...this.modifiedBy];
        clone.createdDate = DateQueryModel.clone(this.createdDate);
        clone.modifiedDate = DateQueryModel.clone(this.modifiedDate);

        return clone;
    }

    isEqual(other: ChartContentFilterModel): boolean {
        if (!isEqual(this.names, other.names )) {
            return false;
        }

        if (!isEqual(this.status, other.status )) {
            return false;
        }

        if (!isEqual(this.searchType, other.searchType )) {
            return false;
        }

        if (!isEqual(this.listType, other.listType )) {
            return false;
        }

        if (!isEqual(this.createdBy, other.createdBy )) {
            return false;
        }

        if (!isEqual(this.modifiedBy, other.modifiedBy )) {
            return false;
        }

        if (!DateQueryModel.equals(this.createdDate, other.modifiedDate)) {
            return false;
        }

        if (!DateQueryModel.equals(this.modifiedDate, other.modifiedDate)) {
            return false;
        }

        return true;
    }
};
